import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isGroupsNudgeEnabled(): boolean {
    return (
        (isFeatureEnabled('grp-readingPaneNudge') && getUserConfiguration().GroupsEnabled) ?? false
    );
}
